function parseHTML(html){const template=document.createElement('template');template.innerHTML=html;return template.content;}
import {closeDrawer,cancelDrawerClose} from './hc-drawer-motion.js?v=833b6b845c6b';
const resultKey=value=>{const url=new URL(value,location.href);url.hash='';url.searchParams.delete('section_id');url.searchParams.sort();return url.href;};
class HCSearchResults extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    this.cache = new Map([[resultKey(location.href), {html:this.outerHTML, at:Date.now()}]]);
    const options = {signal: this.abort.signal};
    const query = selector => this.querySelector(selector);
    const close = () => {
      closeDrawer(query('[data-hc-search-dialog][open]'));
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('hc-modal-open');
    };
    const jump = () => {
      const target = query('.hc-search-grid');
      if (!target) return;
      const toolbar = query('.hc-collection-toolbar');
      const offset = parseFloat(getComputedStyle(this).getPropertyValue('--hc-mobile-filter-offset')) || 0;
      window.scrollTo({top: Math.max(0, target.getBoundingClientRect().top + scrollY - offset - (toolbar?.offsetHeight || 0) - 12), behavior: 'instant'});
    };
    const formURL = form => {
      const url = new URL(form.action, location.href);
      for (const [key, value] of new FormData(form)) if (String(value).trim()) url.searchParams.append(key, value);
      return url;
    };
    const load = async (value, push = true, keepFilters = false) => {
      const url = new URL(value, location.href);
      if (url.origin !== location.origin) return;
      const current = new URL(location.href);
      for (const key of ['view', 'preview_theme_id']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      url.searchParams.delete('section_id');
      if (!keepFilters) close();
      this.moreObserver?.disconnect();
      this.moreRequest?.abort(); this.moreRequest=null;
      clearTimeout(this.moreTimer);
      const appendSkeleton=query('[data-hc-search-append-loading]');
      if(appendSkeleton)appendSkeleton.hidden=true;
      query('[data-hc-search-more]')?.removeAttribute('aria-disabled');
      this.request?.abort();
      this.request = new AbortController();
      const request = this.request;
      clearTimeout(this.timer);
      this.setAttribute('aria-busy', 'true');
      const grid = query('.hc-search-grid'), skeleton = query('[data-hc-search-loading]'), status = query('[data-hc-search-status]');
      grid.hidden = false; skeleton.hidden = true; status.textContent = '';
      this.timer = setTimeout(() => {
        grid.hidden = true; skeleton.hidden = false; status.textContent = this.dataset.loading;
      }, 180);
      if (!keepFilters) jump();
      try {
        const cached = this.cache.get(resultKey(url));
        let html = cached && Date.now() - cached.at < 120000 ? cached.html : null;
        if (!html) {
          const sectionURL = new URL(url);
          sectionURL.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(sectionURL, {signal: request.signal});
          if (!response.ok) throw Error('search');
          html = await response.text();
        }
        if (request.signal.aborted || !this.isConnected) return;
        const incoming = parseHTML(html).querySelector('hc-search-results');
        if (!incoming?.querySelector('.hc-search-grid')) throw Error('search');
        incoming.querySelectorAll('script,noscript').forEach(script => script.remove());
        this.cache.set(resultKey(url), {html, at:Date.now()});
        if (this.cache.size > 12) this.cache.delete(this.cache.keys().next().value);
        clearTimeout(this.timer);
        const panel = keepFilters && query('[data-hc-search-dialog][open]');
        const nextPanel = panel && incoming.querySelector('[data-hc-search-dialog]');
        let focus, scroll = 0, modal = false;
        if (nextPanel) {
          modal = panel.matches(':modal'); scroll = panel.scrollTop;
          const active = document.activeElement;
          if (panel.contains(active)) focus = {name:active.name,value:active.value};
          const facets = new Map([...panel.querySelectorAll('[data-hc-facet]')].map(f => [f.dataset.hcFacet,{hidden:f.hidden,open:f.open}]));
          panel.querySelector('form').replaceWith(nextPanel.querySelector('form'));
          panel.querySelectorAll('[data-hc-facet]').forEach(f => {const state=facets.get(f.dataset.hcFacet);if(state){f.hidden=state.hidden;f.open=state.open;}});
          nextPanel.replaceWith(panel);
        }
        this.replaceChildren(...incoming.childNodes);
        if (nextPanel) {
          if(modal){panel.removeAttribute('open');panel.showModal();}
          panel.scrollTop=scroll;
          if(focus)[...panel.querySelectorAll('input')].find(i=>i.name===focus.name&&i.value===focus.value)?.focus({preventScroll:true});
        }
        if (push) history.pushState(history.state, '', url);
        if (!keepFilters) {
          jump();
          query('.hc-search-grid').setAttribute('tabindex', '-1');
          query('.hc-search-grid').focus({preventScroll: true});
        }
        document.dispatchEvent(new Event('hc:products-updated'));
      } catch (error) {
        if (error.name !== 'AbortError') {
          status.textContent = this.dataset.error;
          const retry = document.createElement('button');
          retry.type = 'button'; retry.className = 'hc-all-filters'; retry.textContent = this.dataset.retry;
          retry.addEventListener('click', () => load(url, push, keepFilters), {once: true});
          status.append(' ', retry);
        }
      } finally {
        if (this.request === request) {
          clearTimeout(this.timer); grid.hidden = false; skeleton.hidden = true;
          this.removeAttribute('aria-busy');
          observeMore();
        }
      }
    };
    const observeMore = () => {
      this.moreObserver?.disconnect();
      const link = query('[data-hc-search-more]');
      if (link) this.moreObserver.observe(link);
    };
    const loadMore = async () => {
      const link = query('[data-hc-search-more]');
      if (!link || this.moreRequest || this.hasAttribute('aria-busy')) return;
      this.moreObserver.disconnect();
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return;
      const current = new URL(location.href);
      for (const key of ['view','preview_theme_id']) if (current.searchParams.has(key)) url.searchParams.set(key,current.searchParams.get(key));
      url.searchParams.delete('section_id');
      const request = new AbortController();
      this.moreRequest = request;
      const skeleton = query('[data-hc-search-append-loading]'), status = query('[data-hc-search-more-status]');
      link.setAttribute('aria-disabled','true');
      status.textContent = '';
      this.moreTimer = setTimeout(() => {skeleton.hidden=false;status.textContent=this.dataset.loadingMore;},180);
      let success = false;
      try {
        const cached = this.cache.get(resultKey(url));
        let html = cached && Date.now()-cached.at<120000 ? cached.html : null;
        if (!html) {
          const sectionURL = new URL(url);
          sectionURL.searchParams.set('section_id',this.dataset.sectionId);
          const response = await fetch(sectionURL,{signal:request.signal});
          if (!response.ok) throw Error('search');
          html = await response.text();
        }
        if (request.signal.aborted || !this.isConnected || this.moreRequest !== request) return;
        const incoming = parseHTML(html).querySelector('hc-search-results');
        const incomingGrid = incoming?.querySelector('.hc-search-grid');
        if (!incomingGrid) throw Error('search');
        const grid = query('.hc-search-grid');
        const position = {top:scrollY,left:scrollX,behavior:'instant'};
        const seen = new Set([...grid.children].map(card=>card.dataset.hcProductId));
        const cards = [...incomingGrid.children].filter(card=>!seen.has(card.dataset.hcProductId));
        cards.forEach(card=>card.style.removeProperty('--hc-card-index'));
        grid.append(...cards);
        if (grid.children.length) query('.hc-collection-empty')?.remove();
        this.cache.set(resultKey(url),{html,at:Date.now()});
        if (this.cache.size>12) this.cache.delete(this.cache.keys().next().value);
        const next = incoming.querySelector('[data-hc-search-more]');
        if (next && new URL(next.href,location.href).searchParams.get('page') !== url.searchParams.get('page')) link.href=next.getAttribute('href');
        else link.remove();
        status.textContent = next ? '' : this.dataset.end;
        window.scrollTo(position);
        success = true;
        document.dispatchEvent(new Event('hc:products-updated'));
      } catch(error) {
        if (error.name!=='AbortError') {status.textContent=this.dataset.moreError;link.textContent=this.dataset.retry;}
      } finally {
        if (this.moreRequest === request) {
          clearTimeout(this.moreTimer);skeleton.hidden=true;
          link.removeAttribute('aria-disabled');this.moreRequest=null;
          if (success) observeMore();
        }
      }
    };
    this.moreObserver = new IntersectionObserver(entries=>{
      if(entries.some(entry=>entry.isIntersecting))loadMore();
    },{rootMargin:'400px'});
    observeMore();
    this.addEventListener('click', event => {
      const dialog = query('[data-hc-search-dialog]');
      const trigger = event.target.closest('[data-hc-search-filter-open]');
      if (trigger && dialog) {
        cancelDrawerClose(dialog);if(dialog.open)dialog.close(); this.opener = trigger;
        const key = trigger.dataset.hcSearchFilterOpen;
        dialog.classList.remove('hc-filter-dragged'); dialog.style.removeProperty('left'); dialog.style.removeProperty('top');
        dialog.classList.toggle('hc-filter-quick', Boolean(key));
        dialog.querySelectorAll('[data-hc-facet]').forEach(facet => {facet.hidden = Boolean(key) && facet.dataset.hcFacet !== key; if (!facet.hidden) facet.open = true;});
        if (key) {
          const rect = trigger.getBoundingClientRect();
          dialog.style.setProperty('--hc-filter-left', `${Math.max(12, Math.min(rect.left, innerWidth - 332))}px`);
          dialog.style.setProperty('--hc-filter-top', `${Math.max(8, Math.min(rect.bottom + 8, innerHeight - 280))}px`);
          dialog.show();
        } else {dialog.showModal(); document.body.classList.add('hc-modal-open');}
      }
      if (event.target.closest('[data-hc-search-filter-close]')) close();
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      }
      const more = event.target.closest('[data-hc-search-more]');
      if (more && event.button===0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {event.preventDefault();loadMore();return;}
      const link = event.target.closest('.hc-active-filters a');
      if (link && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {event.preventDefault(); load(link.href);}
    }, options);
    this.addEventListener('cancel',event=>{if(event.target.matches('[data-hc-search-dialog]')){event.preventDefault();close();}},{...options,capture:true});
    this.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('hc-modal-open');
      this.opener?.focus({preventScroll: true});
    }, {...options, capture: true});
    this.addEventListener('submit', event => {
      if (event.target.matches('[data-hc-search-sort-form],[data-hc-search-dialog] form')) {event.preventDefault(); load(formURL(event.target));}
    }, options);
    this.addEventListener('change', event => {
      const input = event.target;
      if (!input.matches('[data-hc-search-sort],[data-hc-search-dialog] input')) return;
      if (input.form.reportValidity()) load(formURL(input.form), true, Boolean(input.closest('[data-hc-search-dialog]')));
    }, options);
    let drag;
    this.addEventListener('pointerdown', event => {
      const header = event.target.closest('[data-hc-search-dialog]>header');
      if (!header || event.target.closest('button') || event.button !== 0) return;
      const panel = header.parentElement, rect = panel.getBoundingClientRect();
      drag = {panel, x:event.clientX, y:event.clientY, left:rect.left, top:rect.top};
      header.setPointerCapture(event.pointerId); event.preventDefault();
    }, options);
    this.addEventListener('pointermove', event => {
      if (!drag) return;
      const rect = drag.panel.getBoundingClientRect(); drag.panel.classList.add('hc-filter-dragged');
      drag.panel.style.left = `${Math.max(0, Math.min(innerWidth-rect.width, drag.left+event.clientX-drag.x))}px`;
      drag.panel.style.top = `${Math.max(0, Math.min(innerHeight-rect.height, drag.top+event.clientY-drag.y))}px`;
    }, options);
    for (const type of ['pointerup','pointercancel']) this.addEventListener(type, () => {drag=null;}, options);
    document.addEventListener('click', event => {
      const panel = query('.hc-filter-quick[open]');
      if (panel && !panel.contains(event.target) && !event.target.closest('[data-hc-search-filter-open]')) close();
    }, {...options,capture:true});
    window.addEventListener('popstate', () => load(location.href, false), options);
  }
  disconnectedCallback() {
    cancelDrawerClose(this.querySelector('[data-hc-search-dialog]'));
    this.querySelector('[data-hc-search-dialog][open]')?.close();
    this.moreObserver?.disconnect();this.moreRequest?.abort();clearTimeout(this.moreTimer);
    this.request?.abort(); clearTimeout(this.timer); this.abort?.abort(); this.abort=null;
    if (!document.querySelector('dialog[open]')) document.body.classList.remove('hc-modal-open');
  }
}
if (!customElements.get('hc-search-results')) customElements.define('hc-search-results', HCSearchResults);
